module.exports = __webpack_public_path__ + "img/juist-voor-brildragers1.c18ce4c7.svg";